import { createTranslations } from '@npco/utils-translations'

export const cardTransactionsMissingDetailsCountCellTranslations =
  createTranslations({
    outstandingSingle: '1 Outstanding Expense',
    outstandingPlural: '{count} Outstanding Expenses',
    outstandingTransactionsCountMax: '99+',
  })
